<template>
  <div class="dt-mb20">
    <div class="filters-wrap d-flex align-items-center">
      <div id="order-filters-id" :class="checNotifClass">
        <div
          class="d-flex justify-content-between align-items-center plr16"
          :class="[
            clientPlatform == 'Web' ? 'filter-sticky-container pl0' : '',
          ]"
        >
          <div class="d-flex align-items-center width95">
            <div
              class="order-filters flex-row align-items-start align-item-center"
            >
              <div
                v-for="(item, index) in filters"
                :key="index"
                :class="filterClasses[item.type]"
                @click="applyFilterAndSorts(item, $event, index)"
                :dependentComputedProps="{
                  appliedFilters,
                }"
              >
                <div><i :class="filterIconPre[item.type]"></i></div>
                <div class="order-filter-title">{{ item.title }}</div>
              </div>
            </div>
          </div>
          <div
            class="order-filter-search"
            v-on:click="triggerSearchModal($event)"
          >
            <i class="hkfi-search-lens tc search-icon-of"></i>
          </div>
        </div>
        <div
          class="pizza-counter fs-11 lh16 pt3"
          v-if="
            productCounterString &&
            !productCounterString?.startsWith('undefined')
          "
        >
          {{ productCounterString }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GenericModal from "./GenericModal.vue";
// import "vue3-carousel/dist/carousel.css";
import { keyMapsMutation, keyMapsGetter } from "../helpers/storeKeys";
import Utility from "../helpers/utility";
import {
  EVENT_CLICK_SEARCHICON,
  EVENT_CLICK_FILTERS,
} from "../helpers/analyticsEvents";
import LocalStorageFunc from "../helpers/localStorageFunc";
import { clientPlatform } from "../config/apiEndpoints";
export default {
  name: "ProductFilters",
  props: ["dataResults", "moduleProps"],

  components: {
    GenericModal,
  },

  data() {
    return {
      msModalDim: {
        width: "100vw",
        height: "calc(91vh - 56px)",
        animationStyle: "slide-up-stick-bottom",
        modalClass: "modal-bg-blackout",
      },
      filterIconPre: {
        VEG: "tag-veg mr5",
        NONVEG: "tag-non-veg mr5",
        ALL: "tag-s-",
      },
      filterClasses: {},
      filters: [],
      sortOptions: [],
      cachedComponentOffsetTop: 0,
      clientPlatform,
    };
  },

  mounted() {
    let dR = Utility.tryJsonParse(this.dataResults, []);

    this.filters = dR.filter((_) => {
      return _.group == "FILTER";
    });
    this.sortOptions = dR.filter((_) => {
      return _.group == "SORT";
    });

    this.loadInitialFilters();

    window.addEventListener("scroll", () => {
      this.watchSticky();
    });
  },

  destroyed() {
    window.removeEventListener("scroll", this.watchSticky);
  },

  methods: {
    watchSticky() {
      let componentRef = document.getElementById("order-filters-id");
      if (!componentRef) return;

      if (!this.cachedComponentOffsetTop && componentRef.offsetTop > 0) {
        this.cachedComponentOffsetTop = componentRef.offsetTop;
      }

      if (window.pageYOffset >= this.cachedComponentOffsetTop) {
        componentRef.classList.add("sticky");
      } else {
        componentRef.classList.remove("sticky");
      }
    },
    applyFilterAndSorts(item, e, index) {
      if (this.appliedFilters.includes(item.type)) {
        this.$store.commit(keyMapsMutation.UPDATE_APPLIED_FILTERS_AND_SORTS, {
          FILTERS: ["ALL"],
          SORTS: this.appliedSorts,
        });
        EVENT_CLICK_FILTERS({
          category: item.title,
          subCategory: "filter unchecked",
          positionWithinSection: index + 1,
        });
      } else {
        this.$store.commit(keyMapsMutation.UPDATE_APPLIED_FILTERS_AND_SORTS, {
          FILTERS: [item.type],
          SORTS: this.appliedSorts,
        });
        EVENT_CLICK_FILTERS({
          category: item.title,
          subCategory: "filter checked",
          positionWithinSection: index + 1,
        });
      }
    },
    updateAppliedFiltersInLocalStorage() {},
    loadInitialFilters() {
      this.$store.commit(keyMapsMutation.UPDATE_APPLIED_FILTERS_AND_SORTS, {
        FILTERS: ["ALL"],
        SORTS: [],
      });
    },
    resetFilterRelatedUI() {
      this.$store.commit(keyMapsMutation.UPDATE_APPLIED_FILTERS_AND_SORTS, {
        FILTERS: [],
        SORTS: [],
      });
    },
    goto() {},
    triggerSearchModal(e) {
      document.body.classList.add("body-stop-scroll-mobile");
      this.$store.commit(keyMapsMutation.UPDATE_SHOW_SEARCH_MODAL, true);
      EVENT_CLICK_SEARCHICON({ positionWithinSection: 2 });
    },
  },
  computed: {
    productCounterString() {
      return this.$store.state.ProductItems.productCounterString;
    },
    appliedFilters() {
      let flts = this.$store.getters[keyMapsGetter.GET_APPLIED_FILTERS];
      this.filters.map((flt) => {
        if (flts.includes(flt.type)) {
          this.filterClasses[flt.type] =
            "order-filter-item flex-row fs-12 lh-18 ml5 selected-filter-item";
        } else {
          this.filterClasses[flt.type] =
            "order-filter-item flex-row fs-12 lh-18 ml5";
        }
      });
      return flts;
    },
    appliedSorts() {
      return this.$store.getters[keyMapsGetter.GET_APPLIED_SORTS];
    },
    isNotificationVisible() {
      return this.$store.state.Notification.notificationVisibilityStatus;
    },
    getNotificationPosition() {
      return this.$store.state.Notification.notificationPosition;
    },
    checNotifClass() {
      if (!this.isNotificationVisible) {
        this.watchSticky();
        return "no-notif";
      }

      if (this.getNotificationPosition == "show-notif-top") {
        return "sm-notif-top";
      } else if (this.getNotificationPosition == "show-notif-top-big") {
        return "bg-notif-top";
      } else {
        return "no-notif";
      }
    },
  },
};
</script>

<style scoped></style>
